import React, { useEffect, useRef, useState } from "react";
import { Button, Form, InputGroup, Modal } from "@themesberg/react-bootstrap";
import Template from "./TemplateService";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import PopOver from "./PopOver";
import { useTranslation } from "react-i18next";
import AlertDismissible from "../../../components/old/AlertDismissible";
import { messageShown } from "../../../store/reducers/message";
import { useDispatch } from "react-redux";
import CustomSpinner from "../../../components/CustomSpinner";

const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
};

function CreateTemplate({ show, handleClose, templateId, setRefreshData }) {
  const { t } = useTranslation();
  const fileInputRef = useRef(null);
  const dispatch = useDispatch();

  const [marginTop, setMarginTop] = useState(null);
  const [marginBottom, setMarginBottom] = useState(null);
  const [Name, setName] = useState("");
  const [backgroundImage, setBackgroundImage] = useState("");
  const [showLogo, setshowLogo] = useState(true);
  const [closeText, setCloseText] = useState("");
  const [primaryColor, setPrimaryColor] = useState("");
  const [secondaryColor, setSecondaryColor] = useState("");
  const [isDefault, setIsDefault] = useState("");
  const [message, setMessage] = useState();
  const [primaryPickerShow, setPrimaryPickerShow] = useState(false);
  const [secondaryPickerShow, setSecondaryPickerShow] = useState(false);
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  const [viewBackgroundImage, setViewBackgroundImage] = useState("");
  const [fileName, setFileName] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  console.log(isLoading, "isLoading");

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFileName(file ? file.name : "");
    setBackgroundImage(e.target.files);
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  useEffect(() => {
    if (templateId) {
      setIsLoading(true);
      Template.getTemplate(templateId).then((data) => {
        if (data && data.template) {
          setName(data.template.name);
          setMarginTop(data.template.margin_top);
          setMarginBottom(data.template.margin_bottom);
          setshowLogo(data.template.show_logo === 1);
          setPrimaryColor(data.template.theme_color_primary);
          setIsDefault(data.template.is_default === 1);
          setSecondaryColor(data.template.theme_color_secondary);
          setCloseText(data.template.closing_text);
          setBackgroundImage(data.template.background_image);
          let backgroundImageUrl =
            data.template.background_image_url.split("/");
          if (backgroundImageUrl.length >= 5) {
            setViewBackgroundImage(data.template.background_image_url);
          }
          setIsLoading(false);
        }
      });
    } else {
      clearForm();
    }
  }, [templateId]);

  const clearForm = () => {
    setName("");
    setMarginTop(null);
    setMarginBottom(null);
    setBackgroundImage("");
    setIsDefault("");
    setshowLogo("");
    setCloseText("");
    setPrimaryColor("");
    setSecondaryColor("");
  };

  const createORUpdateTemplate = async () => {
    if (
      Name.trim() === "" ||
      marginTop === "" ||
      marginTop === null ||
      marginBottom === "" ||
      marginBottom === null ||
      primaryColor.trim() === "" ||
      secondaryColor.trim() === ""
    ) {
      setMessage({
        message: t("Please fill all required fields"),
        variant: "danger",
      });
      return;
    }

      const formData = new FormData();
      if (templateId) {
          formData.append("id", templateId);
      }
      formData.append("name", Name);
      formData.append("margin_top", marginTop ? parseInt(marginTop) : 0);
      formData.append("margin_bottom", marginBottom ? parseInt(marginBottom) : 0);
      formData.append("show_logo", !!showLogo);
      formData.append("theme_color_primary", primaryColor);
      formData.append("theme_color_secondary", secondaryColor);
      formData.append("closing_text", closeText);
      formData.append("is_default", !!isDefault);

      if (backgroundImage && typeof backgroundImage !== "string" && backgroundImage.length > 0) {
          formData.append("background_image", backgroundImage[0]);
      }

      try {
          if (templateId) {
              const data = await Template.UpdateTemplate(templateId, formData);
              setRefreshData(true);
              dispatch(
                  messageShown({
                      message: data.message,
                      success: data.success,
                      variant: "success",
                  })
              );
              handleClose();
          } else {
              const data = await Template.CreateTemplate(formData);
              dispatch(
          messageShown({
            message: data.message,
            success: data.success,
            variant: "success",
          })
        );
        setRefreshData("create"); //set "create" string value to set last temmplate id for auto select after create new template
        clearForm();
        handleClose();
      }
    } catch (error) {
      dispatch(messageShown({ message: error.message, variant: "danger" }));
    }
  };

  //Get window dimensions
  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div>
      <Modal
        enforceFocus={false}
        show={show}
        onHide={() => handleClose()}
        size="lg"
        className="p-0"
        style={{
          height:
            windowDimensions.width <= 768
              ? windowDimensions.width > 540
                ? "90vh"
                : "70vh"
              : "",
        }}
      >
        <Form>
          <Modal.Header closeButton>
            <Modal.Title>
              {templateId ? t("update template") : t("New Template")}
            </Modal.Title>
          </Modal.Header>
          {message && (
            <AlertDismissible
              textMessage={message.message}
              variant={message.variant}
              onAfterClose={() => setMessage(null)}
            />
          )}
          {isLoading ? (
            <CustomSpinner />
          ) : (
            <>
              <Modal.Body>
                <div className="row">
                  <Form.Group className="col">
                    <Form.Label>{t("Name")}*</Form.Label>
                    <Form.Control
                      type="text"
                      value={Name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </Form.Group>
                </div>
                <div className="row mt-2">
                  <Form.Group className="col-md-6">
                    <Form.Label>{t("Margin Top")}*</Form.Label>
                    <Form.Control
                      type="number"
                      value={marginTop || ""}
                      onChange={(e) => setMarginTop(e.target.value)}
                    />
                  </Form.Group>
                  <Form.Group className="col-md-6">
                    <Form.Label>{t("Margin Bottom")}*</Form.Label>
                    <Form.Control
                      type="number"
                      value={marginBottom || ""}
                      onChange={(e) => setMarginBottom(e.target.value)}
                    />
                  </Form.Group>
                </div>
                <div className="mt-2">
                  <Form.Group className="row">
                    <div className="col-lg-3">
                      <Form.Label>{t("Primary Theme Color")}*</Form.Label>
                      <InputGroup className="mb-3">
                        <InputGroup.Text
                          id="basic-addon1"
                          style={{ width: "25%" }}
                        >
                          <span
                            style={{
                              width: "100%",
                              height: 20,
                              backgroundColor: primaryColor,
                            }}
                          ></span>
                        </InputGroup.Text>
                        <InputGroup.Text style={{ width: "75%" }}>
                          <PopOver
                            color={primaryColor}
                            pickerShow={primaryPickerShow}
                            setPickerShow={setPrimaryPickerShow}
                            handleColorChange={setPrimaryColor}
                          />
                        </InputGroup.Text>
                      </InputGroup>
                    </div>

                    <div className="col-lg-3">
                      <Form.Label>{t("Secondary Theme Color")}*</Form.Label>
                      <InputGroup className="mb-3">
                        <InputGroup.Text
                          id="basic-addon1"
                          style={{ width: "25%" }}
                        >
                          <span
                            style={{
                              width: "100%",
                              height: 20,
                              backgroundColor: secondaryColor,
                            }}
                          ></span>
                        </InputGroup.Text>
                        <InputGroup.Text style={{ width: "75%" }}>
                          <PopOver
                            color={secondaryColor}
                            pickerShow={secondaryPickerShow}
                            setPickerShow={setSecondaryPickerShow}
                            handleColorChange={setSecondaryColor}
                          />
                        </InputGroup.Text>
                      </InputGroup>
                    </div>

                    <div className="col-md-3">
                      <Form.Label>{t("Set Default")}</Form.Label>
                      <div className="mt-2">
                        <BootstrapSwitchButton
                          checked={isDefault}
                          onlabel={t("Yes")}
                          offlabel={t("No")}
                          onstyle="success"
                          offstyle="danger"
                          onChange={(checked) => {
                            setIsDefault(checked);
                          }}
                        />
                      </div>
                    </div>

                    <div className="col-md-3">
                      <Form.Label>{t("Show Logo")}*</Form.Label>
                      <br />
                      <div className="mt-2">
                        <BootstrapSwitchButton
                          checked={showLogo}
                          onlabel="Yes"
                          onstyle="success"
                          offlabel="No"
                          offstyle="danger"
                          onChange={(checked) => {
                            setshowLogo(checked);
                          }}
                        />
                      </div>
                    </div>
                  </Form.Group>
                </div>
                <div className="row mt-2">
                  <Form.Group className="col-md-12">
                    <Form.Label>{t("Closing text")}</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows="2"
                      value={closeText || ""}
                      onChange={(e) => setCloseText(e.target.value)}
                    />
                  </Form.Group>
                </div>
                <div className="row mt-2">
                  <Form.Group className="col-md-12">
                    <Form.Label>{t("Background Image")}</Form.Label>

                    <div className="input-group" onClick={handleClick}>
                      <button type="button" className="file-btn">
                        {t("Choose File")}
                      </button>
                      <input
                        type="text"
                        className="form-control bg-white px-3"
                        value={fileName || t("No file chosen")}
                        readOnly
                        disabled
                      />
                    </div>

                    <Form.Control
                      type="file"
                      ref={fileInputRef}
                      onChange={handleFileChange}
                      style={{ display: "none" }}
                    />
                  </Form.Group>
                  <div className="image-preview col-md-12 text-center">
                    {templateId && viewBackgroundImage && (
                      <img
                        src={`${viewBackgroundImage}`}
                        width="100"
                        height="100"
                        alt="background"
                      />
                    )}
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="outline-primary" onClick={() => handleClose()}>
                  {t("Close")}
                </Button>
                <Button
                  variant="primary"
                  onClick={() => createORUpdateTemplate()}
                  disabled={isLoading}
                >
                  {templateId ? t("update template") : t("create template")}
                </Button>
              </Modal.Footer>
            </>
          )}
        </Form>
      </Modal>
    </div>
  );
}

export default CreateTemplate;
